module.exports = __webpack_public_path__ + "media/icons/user-60b4d3ec.svg";